import {
  removeAllVuePreloadHiddenClasses,
  removeAllVuePostloadHiddenElements
} from './util';

removeAllVuePreloadHiddenClasses();
removeAllVuePostloadHiddenElements();

